if (!customElements.get('cart-upsells')) {
  customElements.define(
    'cart-upsells',
    class CartUpsells extends HTMLElement {
      constructor() {
        super();
        this.messageModal = this.querySelector('[data-card-message-modal]');
        this.messageInput = this.querySelector('[data-card-message-input]');
        this.messageCount = this.querySelector('[data-card-message-count]');
        this.modalImage = this.querySelector('[data-card-message-image]');
        this.modalLabel = this.querySelector('[data-card-message-product-label]');
        this.modalSubmit = this.querySelector('[data-card-message-submit]');
        this.pendingCardButton = null;
        this.boundModalClickHandler = (event) => {
          const closeButton = event.target.closest('[data-card-message-close]');
          if (closeButton) {
            event.preventDefault();
            this.closeMessageModal();
            return;
          }

          const submitButton = event.target.closest('[data-card-message-submit]');
          if (submitButton) {
            event.preventDefault();
            this.submitCardWithMessage();
          }
        };

        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-cart-upsell-toggle]');
          if (toggle) {
            event.preventDefault();
            const toggleTarget = toggle.dataset.cartUpsellToggle;
            if (toggleTarget) {
              this.classList.toggle(`is-${toggleTarget}-open`);
            }
            return;
          }

          const addButton = event.target.closest('[data-cart-upsell-add]');
          if (!addButton) return;

          event.preventDefault();
          if (addButton.disabled) return;

          const variantId = addButton.dataset.variantId;
          if (!variantId) return;

          if (addButton.dataset.cartUpsellRequiresMessage === 'true') {
            this.openMessageModal(addButton);
            return;
          }

          this.addToCart(variantId, addButton);
        });

        if (this.messageModal && this.messageModal.parentElement !== document.body) {
          document.body.appendChild(this.messageModal);
        }

        this.messageInput?.addEventListener('input', () => this.updateMessageCount());
        this.messageModal?.addEventListener('click', this.boundModalClickHandler);
      }

      disconnectedCallback() {
        this.messageModal?.removeEventListener('click', this.boundModalClickHandler);
        if (this.messageModal && this.messageModal.parentElement === document.body) {
          this.messageModal.remove();
        }
      }

      updateMessageCount() {
        if (!this.messageInput || !this.messageCount) return;
        this.messageCount.textContent = `${this.messageInput.value.length} / 200`;
      }

      openMessageModal(addButton) {
        if (!this.messageModal) return;
        this.pendingCardButton = addButton;
        if (this.modalImage) {
          this.modalImage.src = addButton.dataset.upsellImage || '';
          this.modalImage.alt = addButton.dataset.upsellTitle || '';
        }
        if (this.modalLabel) {
          const title = addButton.dataset.upsellTitle || '';
          const price = addButton.dataset.upsellPrice || '';
          const titleElement = document.createElement('span');
          const priceElement = document.createElement('span');

          titleElement.textContent = title;
          priceElement.className = 'cart-upsell-modal__product-price';
          priceElement.textContent = price;

          this.modalLabel.replaceChildren(titleElement, priceElement);
        }
        if (this.messageInput) {
          this.messageInput.value = '';
          this.updateMessageCount();
          this.messageInput.focus();
        }
        this.messageModal.hidden = false;
      }

      closeMessageModal() {
        if (!this.messageModal) return;
        this.messageModal.hidden = true;
        this.pendingCardButton = null;
      }

      submitCardWithMessage() {
        if (!this.pendingCardButton || !this.modalSubmit) return;
        const variantId = this.pendingCardButton.dataset.variantId;
        if (!variantId) return;
        const message = this.messageInput?.value?.trim() || '';
        const properties = message ? { Nachricht: message } : {};
        this.addToCart(variantId, this.modalSubmit, properties).then(() => {
          this.closeMessageModal();
        });
      }

      forceRefreshDrawer() {
        return fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__upsells', '.cart-drawer__footer'];
            selectors.forEach((selector) => {
              const target = document.querySelector(selector);
              const source = html.querySelector(selector);
              if (target && source) target.replaceWith(source);
            });
          })
          .then(() => fetch(`${routes.cart_url}?section_id=cart-icon-bubble`))
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const target = document.getElementById('cart-icon-bubble');
            const source = html.getElementById('shopify-section-cart-icon-bubble');
            if (target && source) {
              const sourceInner = source.querySelector('.shopify-section');
              if (sourceInner) {
                target.innerHTML = sourceInner.innerHTML;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      addToCart(variantId, addButton, properties = {}) {
        addButton.disabled = true;

        return fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response?.status) {
              throw new Error(response?.description || 'Failed to add upsell card');
            }
            return this.forceRefreshDrawer();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            addButton.disabled = false;
          });
      }
    }
  );
}

